import React, { useState } from 'react';

import { Button } from 'components/ui/button';
import DocumentsModal from './documents/modal';
import LlcTitleCard from './llc_title_card';
import LlcPeopleList from './llc_people_list';
import type { OCCompany } from 'bundles/connect/types';

type Props = {
  llcData: OCCompany;
}

export default function LlcDetails({ llcData }: Props) {
  if (!llcData) return null;
  const [showDocsModal, setShowDocsModal] = useState(false);

  const llcHasDocuments = llcData.filings.length > 0;
  const showDocsButton = () => {
    if (llcHasDocuments) return (
      <Button label="Fetch Documents" variant="outline" onClick={() => setShowDocsModal(true)} />
    );
  };

  return (
    <>
      <LlcTitleCard button={showDocsButton()} llcData={llcData}/>
      <LlcPeopleList llcData={llcData}/>
      {llcHasDocuments && (
        <DocumentsModal
          companyId={llcData.companyNumber}
          jurisdictionCode={llcData.jurisdictionCode}
          show={showDocsModal}
          onHide={() => setShowDocsModal(false)}
        />
      )}
    </>
  );
}
